import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=4efac799&scoped=true&"
import script from "./Part.vue?vue&type=script&lang=ts&"
export * from "./Part.vue?vue&type=script&lang=ts&"
import style0 from "./Part.vue?vue&type=style&index=0&id=4efac799&scoped=true&lang=scss&"
import style1 from "./Part.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efac799",
  null
  
)

export default component.exports